import vert from '@/shaders/bg/sky.vert'
import frag from '@/shaders/intro/bg.frag'
 
import EventEmitter from 'src/helpers/EventEmitter'
import { DEG_TO_RAD, map, clamp } from 'src/helpers/MathUtils'
import MovieClip from 'src/helpers/MovieClip' 

import ResizeService from '@/services/ResizeService'
import ImageService from '@/services/ImageService'
import SpaceshipSpritesheet from '@/assets/sprites/spaceship' 

import Moons from '@/components/Stage/intro/moons'
import Title from '@/components/Stage/intro/title'
import Cave from '@/components/Stage/intro/cave'
import Eyes from '@/components/Stage/intro/eyes'
import Spaceface from '@/components/Stage/intro/spaceface'
import Spaceship from '@/components/Stage/intro/spaceship'
import LoaderSpritesheet from '@/assets/sprites/loader' 

const THREE = require('three')
 
 
class Intro extends THREE.Group { 

  constructor(config) {

    super();

    Object.assign(this, EventEmitter)

    this.renderer = config.renderer;
    this.time = 0; 

    // this.spaceship = new Spaceship();
    // this.add( this.spaceship );
 
    // let texture = this.createTexture(require('@/assets/sprites/spaceship.png'));
    // this.spaceship = new Spaceship({ 
    //   frames: SpaceshipSpritesheet.frames,
    //   frame_width: 512,
    //   frame_height: 512, 
    //   spritesheet_width: SpaceshipSpritesheet.meta.size.w,
    //   spritesheet_height: SpaceshipSpritesheet.meta.size.h, 
    //   texture: texture
    // }); 
    // this.add(this.spaceship);

   
    this.material = new THREE.ShaderMaterial({
      vertexShader : vert,
      fragmentShader : frag,
      uniforms : {  
        startColor: {
           value: new THREE.Vector3(51.0/255.0, 200.0/255.0, 255.0/255.0)  
        },
        endColor: {
           value: new THREE.Vector3(224.0/255.0, 1.0/255.0, 65.0/255.0)
        },
        offset: {
           value: 0.15
        }, 
        time :{
            type : "f",
            value : 0
        }
      }
    });

    this.createBg();
 
    this.cave = new Cave({
      renderer : this.renderer
    });
    this.add(this.cave)

    this.title = new Title();
    this.add(this.title)

    this.moons = new Moons();
    this.add(this.moons)

    this.spaceface = new Spaceface();
    this.add(this.spaceface)
 
    this.eyes = new Eyes();
    this.eyes.position.z = 0;
    this.add(this.eyes) 
  
    this.createLandscape(); 
 

    this.loader_mc = new MovieClip({
      fps: 5,
      frames: LoaderSpritesheet.frames,
      frame_width: 384,
      frame_height: 384,
      spritesheet_width: LoaderSpritesheet.meta.size.w,
      spritesheet_height: LoaderSpritesheet.meta.size.h, 
      texture: this.createTexture(require('@/assets/sprites/loader.png'))
    }); 
    this.loader_mc.position.x = 0;
    this.loader_mc.position.y = 710; 
    this.loader_mc.position.z = -600;
    this.loader_mc.scale.x = this.loader_mc.scale.y = this.loader_mc.scale.z = 0.13;
    this.add(this.loader_mc);
    //this.mc.gotoAndStop(1);
    this.loader_mc.play();
 
    // START
    ResizeService.on(ResizeService.Events.RESIZE, this.resize );
    this.resize() 
  }

  hide() {
    this.visible = false;
  } 
 
  createBg() { 
    this.bg_plane = new THREE.PlaneBufferGeometry(1 , 2900);
    this.bg_mesh = new THREE.Mesh( this.bg_plane, this.material ); 
    this.bg_mesh.position.z = -1500;
    //this.add(this.bg_mesh);
  }

  createLandscape() {
 
    this.landscape = new THREE.Group(); 
    this.landscape.position.y = -700;
    this.landscape.position.z = -13;


    // bg - - - - - - - - - - - 
    let landscape_bg_bg_texture = this.createTexture(require('@/assets/img/surface-bg-bg.png'));
    this.landscape_bg_bg = new THREE.Mesh(
      new THREE.PlaneBufferGeometry(1024, 1024), 
      new THREE.MeshBasicMaterial({
        map: landscape_bg_bg_texture,
        transparent: true
      })
    ); 
    this.landscape_bg_bg.scale.y = this.landscape_bg_bg.scale.x = 0.5; 
    this.landscape_bg_bg.position.z = -650;
    this.landscape_bg_bg.position.x = 0;
    this.landscape_bg_bg.position.y =  -100;

    
    // bg - - - - - - - - - - - 
    let landscape_bg_texture = this.createTexture(require('@/assets/img/surface-bg.png'));
    this.landscape_bg = new THREE.Mesh(
      new THREE.PlaneBufferGeometry(1024, 1024), 
      new THREE.MeshBasicMaterial({
        map: landscape_bg_texture,
        transparent: true
      })
    ); 
    this.landscape_bg.scale.y = this.landscape_bg.scale.x = 0.25; 
    this.landscape_bg.position.z = -370;
    this.landscape_bg.position.x = 170;
    this.landscape_bg.position.y = -120;

    this.landscape_two_bg = new THREE.Mesh(
      new THREE.PlaneBufferGeometry(1024, 1024), 
      new THREE.MeshBasicMaterial({
        map: landscape_bg_texture,
        transparent: true
      })
    ); 
    this.landscape_two_bg.scale.y = this.landscape_two_bg.scale.x = 0.25; 
    this.landscape_two_bg.position.z = -390;
    this.landscape_two_bg.position.x = -200;
    this.landscape_two_bg.position.y = -160;

    this.landscape_three_bg = new THREE.Mesh(
      new THREE.PlaneBufferGeometry(1024, 512), 
      new THREE.MeshBasicMaterial({
        map: this.createTexture(require('@/assets/img/surface-bg-two.png')),
        transparent: true
      })
    ); 
    this.landscape_three_bg.scale.y = this.landscape_three_bg.scale.x = 0.25; 
    this.landscape_three_bg.position.z = -405;
    this.landscape_three_bg.position.x =  0;
    this.landscape_three_bg.position.y = -210;

    this.landscape.add(this.landscape_bg_bg);
    this.landscape.add(this.landscape_bg);
    this.landscape.add(this.landscape_two_bg);
    this.landscape.add(this.landscape_three_bg);
 
    // - - - - - - - - - - - 




    // mg  - - - - - - - - - - - 
    let landscape_mg_texture = this.createTexture(require('@/assets/img/surface-mg.png'));
    this.landscape_mg = new THREE.Mesh(
      new THREE.PlaneBufferGeometry(1024, 256), 
      new THREE.MeshBasicMaterial({
        map: landscape_mg_texture,
        transparent: true
      })
    ); 
    this.landscape_mg.scale.y = this.landscape_mg.scale.x = 0.32;
    this.landscape_mg.position.z = -320;
    this.landscape_mg.position.y = -250;
    this.landscape_mg.position.x = 100;

     this.landscape_two_mg = new THREE.Mesh(
      new THREE.PlaneBufferGeometry(1024, 256), 
      new THREE.MeshBasicMaterial({
        map: landscape_mg_texture,
        transparent: true
      })
    ); 
    this.landscape_two_mg.scale.y = this.landscape_two_mg.scale.x = 0.32;
    this.landscape_two_mg.position.z = -334;
    this.landscape_two_mg.position.y = -250;
    this.landscape_two_mg.position.x = -100;

    this.landscape.add(this.landscape_mg);
    this.landscape.add(this.landscape_two_mg);

    // fg
    this.sign = new THREE.Mesh(
      new THREE.PlaneBufferGeometry(512, 1024), 
      new THREE.MeshBasicMaterial({
        map: this.createTexture(require('@/assets/img/sign-restricted-access.png')),
        transparent: true
      })
    ); 
    this.sign.scale.y = this.sign.scale.x = 0.15;
    this.sign.position.z = -300;
    this.sign.position.y = -200;



    this.landscape_fg = new THREE.Group(); 
    this.landscape_fg.position.z = -200;

    this.pipe = new THREE.Mesh(
      new THREE.PlaneBufferGeometry(1024 , 128 ), 
      new THREE.MeshBasicMaterial({
        map: this.createTexture(require('@/assets/img/pipe.png')),
        transparent: true
      })
    ); 
    this.pipe.position.z = -27; 
    this.pipe.position.y = -300;
    this.pipe.scale.y = this.pipe.scale.x = 0.15;

    let grit_texture = require('@/assets/img/grit.png');
    this.grit = new THREE.Mesh(
      new THREE.PlaneBufferGeometry(512 , 128 ), 
      new THREE.MeshBasicMaterial({
        map: this.createTexture(grit_texture),
        transparent: true
      })
    ); 
    this.grit.position.z = -26; 
    this.grit.position.x = 60; 
    this.grit.position.y = -280;
    this.grit.scale.y = this.grit.scale.x = 0.15;

     this.grit_two = new THREE.Mesh(
      new THREE.PlaneBufferGeometry(512 , 128 ), 
      new THREE.MeshBasicMaterial({
        map: this.createTexture(grit_texture),
        transparent: true
      })
    ); 
    this.grit_two.position.z = -25.3; 
    this.grit_two.position.x = -80; 
    this.grit_two.position.y = -360;
    this.grit_two.rotation.z = -180 * DEG_TO_RAD;
    this.grit_two.scale.y = this.grit_two.scale.x = 0.17;
 
 
    let landscape_fg_texture = this.createTexture(require('@/assets/img/surface-fg.png'))
    this.landscape_fg_one = new THREE.Mesh(
      new THREE.PlaneBufferGeometry(1024, 256), 
      new THREE.MeshBasicMaterial({
        map: landscape_fg_texture,
        transparent: true
      })
    ); 
    this.landscape_fg_one.scale.y = this.landscape_fg_one.scale.x = 0.2;
    this.landscape_fg_one.position.y = -250;
    this.landscape_fg_one.position.x = -100;
    this.landscape_fg_one.position.z = -31;


    this.landscape_fg_two = new THREE.Mesh(
      new THREE.PlaneBufferGeometry(1024, 256), 
      new THREE.MeshBasicMaterial({
        map: landscape_fg_texture,
        transparent: true
      })
    ); 
    this.landscape_fg_two.scale.y = this.landscape_fg_two.scale.x = 0.2; 
    this.landscape_fg_two.position.y = -245;
    this.landscape_fg_two.position.x = 90;
    this.landscape_fg_two.position.z = -32;

    this.landscape_fg.add(this.landscape_fg_one);
    this.landscape_fg.add(this.landscape_fg_two);
    this.landscape_fg.add(this.pipe); 
    this.landscape_fg.add(this.grit); 
    this.landscape_fg.add(this.grit_two); 
 
    this.landscape.add(this.landscape_fg);
    this.landscape.add(this.sign);
 
    this.add(this.landscape);
  }

  createTexture(url){
    let img = ImageService.get(url) 
    let texture = new THREE.Texture(img);   
    texture.needsUpdate = true;
    return texture;
  }

  loaded() {} 
 
  tick(dy, scroll_ratio) {

    // this.spaceship.tick(dy, scroll_ratio);

    this.time++;
    this.material.uniforms.time.value = this.time; 

    this.title.tick(dy)
    this.cave.tick(scroll_ratio);
  }
  
  updateTexture(index){
    this.material.uniforms.startTex.value = this.textures[index]; 
  }

  updateRoute(val) { 
    this.cave.updateRoute(val) 
    this.eyes.updateRoute(val) 
  }

  updateSwipe(val) {  
    this.title.updateSwipe(val);
  }


 
  resize = () => {  
    // this.bg_mesh.scale.x = window.innerWidth * 2.5;
    // this.bg_mesh.scale.x = 2;
    //console.log(this.bg_mesh.scale.x)
  }
 
 
}

export default Intro